export default "__VITE_ASSET__GRKfGmT0__"